<template>
  <div>
    <v-row>
      <v-col class="align-center" sm="6" >
        <v-text-field
          :label="$t('fleet.name') + ' *'"
          v-model="overview.name"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>

      <v-col sm="6">
        <v-text-field
          :label="$t('fleet.licence_plate') + ' *'"
          v-model="overview.licence_plate"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <!-- <v-flex sm6>
        <v-select
          :items="countries"
          attach
          chips
          :label="$t('fleet.allowed_countries')"
          multiple
          v-model="overview.allowed_countries"
        ></v-select>
      </v-flex> -->
      <v-col sm="6">
        <v-text-field
          :label="$t('fleet.cost_per_km') + ' *'"
          value="1.00"
          suffix="EUR"
          type="number"
          v-model="overview.costs.price_per_km"
          :rules="[v => !!v || $t('general.required_field')]"
        ></v-text-field>
      </v-col>
      <v-col sm="6">
        <v-checkbox color="kazan" :label="$t('fleet.internal_vehicle')" v-model="overview.is_internal"></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'VehicleFormOverview',
  props: ['value'],
  data () {
    return {
      countries: ['CZ', 'SK'],
      overview: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    overview: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
